<div class="modal-header">
    <span>
      {{ this.data && this.data.header ? this.data.header : "Message" }}
    </span>
</div>
<div class="modal-body">
  {{ this.data.message }}
</div>
<div class="modal-footer">
  <button
    mat-raised-button
    color="accent"
    aria-label="Submit"
    (click)="onBtnClick(1)"
  >
    {{ this.data && this.data.button1 ? this.data.button1 : "OK" }}
  </button>
  <button
    mat-raised-button
    color="accent"
    class="second"
    [attr.aria-label]="this.data.button2"
    (click)="onBtnClick(2)"
    *ngIf="this.data.button2"
  >
    {{ this.data.button2 }}
  </button>
</div>
